import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const MaternityPaternityPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Maternity_Paternity_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Maternity and Paternity Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy sets out the rights and entitlements of employees relating to maternity and paternity leave and pay, ensuring compliance with the Employment Rights Act 1996, the Maternity and Parental Leave etc. Regulations 1999, and related legislation.
      </p>

      <h4 className="section-title">2. Definitions and Differences</h4>
      <p className="section-content">
        <strong>Maternity Leave:</strong> Leave granted to pregnant employees for childbirth and postnatal recovery. Typically lasts up to 52 weeks, comprising Ordinary Maternity Leave (OML) and Additional Maternity Leave (AML).
      </p>
      <p className="section-content">
        <strong>Paternity Leave:</strong> Leave granted to eligible employees who are the father of the child or the mother's partner (including same-sex partners) to support the mother and care for the newborn. Usually up to 2 weeks.
      </p>

      <h4 className="section-title">3. Eligibility and Qualifying Criteria</h4>
      <p className="section-content">
        <strong>Maternity Leave:</strong> All pregnant employees have the right to take maternity leave regardless of length of service. To qualify for Statutory Maternity Pay (SMP), employees must have at least 26 weeks' continuous service by the 15th week before the expected week of childbirth and earn above the lower earnings limit.
      </p>
      <p className="section-content">
        <strong>Paternity Leave:</strong> To qualify, employees must have at least 26 weeks' continuous service by the 15th week before the expected week of childbirth or by the week they are notified of being matched with a child for adoption. They must be the biological father or partner of the mother or adopter and have responsibility for the child's upbringing.
      </p>

      <h4 className="section-title">4. Leave Entitlement</h4>
      <p className="section-content">
        <strong>Maternity Leave:</strong> Up to 52 weeks leave; 26 weeks Ordinary Maternity Leave (OML) plus 26 weeks Additional Maternity Leave (AML). Employees must give notice 15 weeks before the expected week of childbirth.
      </p>
      <p className="policy-details"><strong>Statutory Maternity Pay:</strong> Paid for up to 39 weeks. 90% of average weekly earnings for first 6 weeks, followed by 33 weeks at the statutory rate (or 90% if lower).</p>
      <p className="section-content">
        <strong>Paternity Leave:</strong> Up to 2 consecutive weeks leave within 56 days of birth or adoption placement. Must provide notice 15 weeks before the expected week of childbirth or within 7 days of being notified of adoption.
      </p>
      <p className="policy-details"><strong>Statutory Paternity Pay:</strong> Paid at the statutory rate or 90% of average weekly earnings, whichever is lower.</p>

      <h4 className="section-title">5. Notification and Procedure</h4>
      <ul>
        <li>Employees must notify their manager or HR in writing of their intention to take maternity or paternity leave by the specified deadlines.</li>
        <li>Provide medical certificates or proof of expected childbirth/adoption as required.</li>
        <li>Confirm return to work dates or apply for extensions as per policy.</li>
      </ul>

      <h4 className="section-title">6. Rights During Leave</h4>
      <p className="section-content">
        Employees on maternity or paternity leave retain rights to job protection, accrual of statutory benefits, and return to their previous role or suitable alternative.
      </p>

      <h4 className="section-title">7. Contact Information</h4>
      <p className="policy-details"><strong>Human Resources:</strong> {hrContact || "[Insert Contact Number]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to abide by the Maternity and Paternity Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default MaternityPaternityPolicy;
